import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Down: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowWall2Down"><Path fillRule="evenodd" clipRule="evenodd" d="M12.75 3V16.9393L16.25 13.4393L17.3107 14.5L12.3106 19.5H20V21H4V19.5H11.6893L6.68934 14.5L7.75 13.4393L11.25 16.9393V3H12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWall2Down;
